export default {
	methods: {
		clickPlanejada() {
			this.form.tipo_voo = ''
			this._exibeModal('modal-tipo-planejada', 60)
			//
		},

		clickExibeModalDiario(tipo, fechaModal) {
			if (fechaModal) {
				this.$refs.modalDiario.modalHide()
				setTimeout(() => {
					this.clickExibeModalDiario(tipo, false)
				}, 400)
			} else {
				this.$refs.modalDiario.modalShow(90)
				this.tipoDBModal = tipo

				this.$nextTick(() => {
					this.$refs.diarioModal.carregaDados({
						data: this.form,
						aero: this.aeronave,
						pilotos: this._pilotos_mecanicos,
						trecho: this.trecho,
						tipo: tipo
					})
				})
			}
		},

		clickInverter() {
			var aux = this.form.para_select
			var auxCidade = ''
			var auxEstado = ''
			var auxCidades = ''
			if (aux.sigla == 'ZZZZ') {
				auxCidade = this.form.nome_cidade_para
				auxEstado = this.form.nome_estado_para
				auxCidades = this.cidadesPara
			}

			this.form.para_select = this.form.de_select
			if (this.form.de_select.sigla == 'ZZZZ') {
				this.cidadesPara = this.cidadesDe
				this.form.nome_estado_para = this.form.nome_estado_de
				this.form.nome_cidade_para = this.form.nome_cidade_de
			}
			this.form.de_select = aux

			if (aux.sigla == 'ZZZZ') {
				this.cidadesDe = auxCidades
				this.form.nome_estado_de = auxEstado
				this.form.nome_cidade_de = auxCidade
			}
		},

		clickSetaTipoDiario() {
			this.$refs.origemVoo.carregaDados(this.aeronave)

			//this.clickPlanejadaOrdem()
			//form.tipo_voo = 'C'
		},

		clickCopiarDe() {
			this.form.para_select = this.form.de_select
			if (this.form.para_select.sigla == 'ZZZZ') {
				this.cidadesPara = this.cidadesDe
				this.form.nome_estado_para = this.form.nome_estado_de
				this.form.nome_cidade_para = this.form.nome_cidade_de
			}
		},

		clickSelecionaPassageiro(index) {
			this.passageirosSelecao[index].selecionado = !this.passageirosSelecao[index].selecionado
			this.$forceUpdate()
		},

		clickImportaPassageiros() {
			_.forEach(this.passageirosSelecao, (item) => {
				if (item.selecionado) {
					this.addPass(item)
				}
			})

			this._escondeModal('modal-ordem-escolha-passageiros')
		},

		clickAddOrgao() {
			this.form.orgao.push({
				orgao: '',
				erroOrgao: '',
				erroTempoVoo: '',
				tempo_voo: 0,
				unidade: []
			})

			this.calculaTempoVooOrgao()
		},

		calculaTempoVooOrgao() {
			// PMSP
			if (this._idCliente == 14) {
				if (this.form.tempo_voo_piloto != 0) {
					var valor = Number(this.form.tempo_voo_piloto / this.form.orgao.length).toFixed(2)
					this.form.orgao = this.form.orgao.map((item) => {
						item.tempo_voo = valor
						return item
					})
				}
			}
		},

		clickAddTripulante() {
			this.form.tripulacao.push({
				id_usuario: '',
				erroUsuario: '',
				funcao: '',
				erroFuncao: '',
				anac: '',
				apresentacao: '',
				erroApresentacao: '',
				codigo_ovn: '',
				erroOVN: '',
				nome: '',
				trigrama: '',
				load: false,
				usuarios: []
			})
		},

		clickAddPassageiro(tipo) {
			this.form.passageiro.push({
				tipo: tipo,
				data_nascimento: '',
				idade_aparente: '',
				idadeErro: '',
				sexo: '',
				sexoErro: '',
				nome: tipo == 'V' ? 'NÃO QUALIFICADO' : '',
				nomeErro: '',
				orgao: '',
				orgaoErro: '',
				cargo: '',
				cargoErro: '',
				cpf: '',
				cpfErro: '',
				telefone: '',
				telefoneErro: ''
			})
		},

		clickAddDiscrepancia() {
			this.form.discrepancia.push({
				id: 0,
				id_usuario: '',
				erroTipo: '',
				trigrama: '',
				tipo: '',
				erroUsuario: '',
				descricao: '',
				erroDescricao: '',
				anac: '',
				acao_discrepancia: [],
				data_conclusao: ''
			})
		},

		clickAddOcorrencia() {
			this.form.ocorrencias.push({
				id: 0,
				data: '',
				erro_data: '',
				local: '',
				erro_local: '',
				codigo_classificacao: '',
				erro_codigo_classificacao: '',
				qualificacao_civil: '',
				erro_qualificacao_civil: '',
				descricao_fatos: '',
				erro_descricao_fatos: ''
			})
		},

		clickSetaAero(item) {
			this.aeronave_import = item
			this.$refs.modalAero.modalHide()
		},

		clickContinuaPreenchendo() {
			bus.$emit('load-in', {text: this._traducao('global', 'atualizandoTempo')})

			this._httpGet('Aeronave/atualiza_tempo_diario/' + $sessao.getId() + '/' + this.aeronave.id, (response) => {
				bus.$emit('load-out')

				if (response._request) {
					this.iniciaVerificacaoFechamento()
					this._escondeModal('modal-ordem-tempo-expirado')
				}
			})
		}
	}
}